import { Link } from "@inertiajs/react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-6">
            <span className="text-lg font-semibold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
              Ukarte
            </span>
            <nav className="flex gap-6 text-sm">
              <Link
                href="/privacy"
                className="text-gray-600 hover:text-gray-900 transition-colors"
              >
                プライバシーポリシー
              </Link>
              <Link
                href="/terms"
                className="text-gray-600 hover:text-gray-900 transition-colors"
              >
                利用規約
              </Link>
            </nav>
          </div>
          <p className="text-gray-500 text-sm">
            © {currentYear} 株式会社WeCoach. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
